import { useState } from 'react';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import Loader from '../shared/Loader';

const ChatImageContent = ({ style, src, onPress }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <div
      style={{
        ...styles.imageContainer,
        ...style,
        cursor: onPress ? 'pointer' : 'default'
      }}
      onClick={(event) => {
        event.stopPropagation();
        onPress();
      }}
    >
      <img
        src={src}
        alt="Chat attachment"
        style={styles.image}
        onLoad={() => setLoading(false)}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
      />

      {loading && !error && (
        <div style={styles.imageOverlay}>
          <Loader />
        </div>
      )}

      {error && (
        <div style={{ ...styles.imageOverlay, backgroundColor: '#f0f0f0' }}>
          <ImageNotSupportedIcon style={{ fontSize: 24, color: '#999' }} />
        </div>
      )}
    </div>
  );
};

const styles = {
  imageContainer: {
    position: 'relative',
    display: 'inline-block',
    width: 200,
    height: 150,
    borderRadius: 8,
    overflow: 'hidden'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    borderRadius: 8
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.6)'
  }
};

export { ChatImageContent };
